import { css, keyframes } from "styled-components";

import { tooltipHost } from "../style";
import { withDefault } from "collection-utils";
import { styled } from "sharedUI/styles";

export const Inner = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
`;

export const WarningWrapper = styled.div`
    position: absolute;
    top: 25px;
    right: 22px;
    > svg {
        color: ${p => p.theme.warningColor};
        width: 22px;
        height: 22px;
    }
`;

const sampleProfileStyles = css`
    color: ${p => p.theme.fgColorAccent};
    background-color: ${p => p.theme.blue};
    border-radius: 12px;

    transition: filter ${p => p.theme.hoverTransition};

    :hover {
        filter: brightness(0.9);
    }
`;

const profileStyles = css`
    color: ${p => p.theme.fgColorAccent};
    background-color: ${p => p.theme.bgColorAccent};
    border-radius: 12px;

    transition: filter ${p => p.theme.hoverTransition};

    :hover {
        filter: brightness(0.9);
    }
`;

const defaultIconStyles = css`
    background: transparent;

    :hover {
        color: ${p => p.theme.fgColorDark};
    }
`;

const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(-360deg);
    }
`;

const spinStyle = css`
    animation-name: ${spin};
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
`;

interface IconWrapperProps {
    isProfileIcon?: boolean;
    isSample?: boolean;
    isSelected?: boolean;
    marginRight: number;
    spin?: boolean;
}

export const IconWrapper = styled.div<IconWrapperProps>`
    padding: 12px;
    margin-right: ${p => p.marginRight}px;
    display: flex;
    justify-content: center;
    align-items: center;

    ${p => {
        if (p.isProfileIcon && p.isSample) {
            return sampleProfileStyles;
        } else if (p.isProfileIcon && !p.isSample) {
            return profileStyles;
        }
        return defaultIconStyles;
    }};

    ${p => p.spin && spinStyle}
`;

export const IconNodeWrapper = styled.div`
    margin-right: 16px;
`;

export const Image = styled.img`
    border-radius: 12px;
    margin-right: 16px;
    width: 48px;
    height: 48px;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
`;

const activeStyles = css`
    background: ${p => p.theme.bgColorMedium};
    color: ${p => p.theme.leftPanelButton.fgActive};
`;

const selectedStyles = css`
    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 24px;
        background: ${p => p.theme.fgColorDark};
    }

    :hover {
        color: ${p => p.theme.fgColorDark};
        cursor: default;
    }

    ${tooltipHost}
`;

interface ButtonProps {
    isActive: boolean;
    isSelected: boolean;
    isEnabled: boolean;
    isClickable?: boolean;
}

export const Button = styled.div<ButtonProps>`
    display: block;
    background: none;
    position: relative;
    width: calc(100% + 48px);
    height: 48px;
    @media screen and (max-height: 800px) {
        height: 40px;
        svg {
            width: 20px;
            height: 20px;
        }
    }
    margin-left: -24px;
    padding: 0 0 0 24px;
    cursor: ${p => (withDefault(p.isClickable, true) ? "pointer" : "default")};
    font-weight: 500;
    font-size: 16px;
    font-family: Roboto, sans-serif;
    color: ${p => p.theme.leftPanelButton.fgColor};

    opacity: ${p => (p.isEnabled ? "1" : "0.4")};

    :hover {
        color: ${p => p.theme.fgColorDark};
    }

    ${tooltipHost}

    ${props => props.isActive && activeStyles}
    ${props => props.isSelected && selectedStyles}
`;
